import { getWorkCollection } from "@/server/interfaces"
import { resolveImgToSmall } from "@/utils/resolveImgToSmall"
import getParamsFromUrl from "@/utils/getParamsFromUrl"
import { getUserInfo, getActivityDetail } from "../../server/interfaces"

export default {
  namespaced: true,
  state: {
    worksList: [],
    noMoreWorkList: false,
    scrollTop: 0,
    activityId: "",
    activityDetail: {},
    userInfo: {
      userId: ""
    }
  },
  getters: {
    worksList: state => state.worksList,
    noMoreWorkList: state => state.noMoreWorkList,
    scrollTop: state => state.scrollTop,
    userInfo: state => state.userInfo,
    singleShareDesc: state => state.activityDetail.singleShareDesc || ""
  },
  mutations: {
    refreshWorksList(state, workList) {
      state.worksList = workList
    },
    saveWorksList(state, workList) {
      state.worksList = [...state.worksList, ...workList]
    },
    setNoMoreWorksList(state, status) {
      state.noMoreWorkList = status
    },
    reviseWorkItem(state, { index, workItem }) {
      const oldWorkItem = state.worksList[index]
      const newWorkItem = { ...oldWorkItem, ...workItem }
      state.worksList.splice(index, 1, newWorkItem)
    },
    saveScrollTop(state, scrollTop) {
      state.scrollTop = scrollTop
    },
    getWorkCollectionUserIdActivityId(state) {
      const { userId, id } = getParamsFromUrl()
      if (userId) {
        state.userId = userId
      }
      if (id) {
        state.activityId = id
      }
    },
    setUserInfo(state, userInfo) {
      state.userInfo = Object.assign({}, state.userInfo, userInfo)
    },
    setActivityDetail(state, activityDetail) {
      state.activityDetail = activityDetail
    }
  },
  actions: {
    async getWorksList({ commit, state }, params) {
      const userId = state.userId
      params.params.userId = userId
      const {
        params: { page }
      } = params
      const { content: workList, last } = await getWorkCollection(params)
      workList.forEach(item => {
        item.defaultOptions.forEach(optionsItem => {
          item[optionsItem.option] = optionsItem.value
        })
        item.mediaFiles = item.mediaFiles || []
        item.videos = item.videos || []
        const mediaCoverItem = item.mediaFiles.find(item => item.cover)
        const mediaCover = mediaCoverItem ? mediaCoverItem.url : ""
        const imgFilesCover = item.mediaFiles[0] ? item.mediaFiles[0].url : ""
        const videoCover = item.videos[0] ? item.videos[0].coverImgUrl : ""
        item.cover = mediaCover || videoCover || imgFilesCover || item.worksDefaultPic
        item.cover = resolveImgToSmall(item.cover)
      })
      if (page === 0) {
        commit("refreshWorksList", workList)
      } else {
        commit("saveWorksList", workList)
      }
      commit("setNoMoreWorksList", last)
    },
    async getUserInfo({ commit, state }) {
      const userId = state.userId
      const params = {
        params: {
          userId
        }
      }
      const userInfo = await getUserInfo(params)
      if (userInfo) {
        if (userInfo.defaultOptions) {
          userInfo.defaultOptions.forEach(item => {
            userInfo[item.option] = item.value
          })
        }
        commit("setUserInfo", userInfo)
      }
    },
    async getActivityInfo({ state, commit }, params) {
      const activityId = state.activityId
      if (!activityId) {
        window.console.error("请传入正确的活动id")
        return false
      }
      const acitvityParams = {
        params: {
          id: activityId
        },
        ...params
      }
      const activityDetail = await getActivityDetail(acitvityParams)
      commit("setActivityDetail", activityDetail)
    }
  }
}
